export const FORMANT_PRESETS = [
  {
    name: "sopranoA",
    freq: [800, 1150, 2900, 3900, 4950],
    amp: [1.0, 0.501187, 0.025119, 0.1, 0.003162],
    reso: [0.1, 0.078261, 0.041379, 0.033333, 0.028283],
  },
  {
    name: "sopranoE",
    freq: [350, 2000, 2800, 3600, 4950],
    amp: [1.0, 0.1, 0.177828, 0.01, 0.001585],
    reso: [0.171429, 0.05, 0.042857, 0.041667, 0.040404],
  },
  {
    name: "sopranoI",
    freq: [270, 2140, 2950, 3900, 4950],
    amp: [1.0, 0.251189, 0.050119, 0.050119, 0.00631],
    reso: [0.222222, 0.042056, 0.033898, 0.030769, 0.024242],
  },
  {
    name: "sopranoO",
    freq: [450, 800, 2830, 3800, 4950],
    amp: [1.0, 0.281838, 0.079433, 0.079433, 0.003162],
    reso: [0.155556, 0.1, 0.035336, 0.034211, 0.027273],
  },
  {
    name: "sopranoU",
    freq: [325, 700, 2700, 3800, 4950],
    amp: [1.0, 0.158489, 0.017783, 0.01, 0.001],
    reso: [0.153846, 0.085714, 0.062963, 0.047368, 0.040404],
  },
  {
    name: "altoA",
    freq: [800, 1150, 2800, 3500, 4950],
    amp: [1.0, 0.630957, 0.1, 0.015849, 0.001],
    reso: [0.1, 0.078261, 0.042857, 0.037143, 0.028283],
  },
  {
    name: "altoE",
    freq: [400, 1600, 2700, 3300, 4950],
    amp: [1.0, 0.063096, 0.031623, 0.017783, 0.001],
    reso: [0.15, 0.05, 0.044444, 0.045455, 0.040404],
  },
  {
    name: "altoI",
    freq: [350, 1700, 2700, 3700, 4950],
    amp: [1.0, 0.1, 0.031623, 0.015849, 0.001],
    reso: [0.142857, 0.058824, 0.044444, 0.040541, 0.040404],
  },
  {
    name: "altoO",
    freq: [450, 800, 2830, 3500, 4950],
    amp: [1.0, 0.354813, 0.158489, 0.039811, 0.001778],
    reso: [0.155556, 0.1, 0.035336, 0.037143, 0.027273],
  },
  {
    name: "altoU",
    freq: [325, 700, 2530, 3500, 4950],
    amp: [1.0, 0.251189, 0.031623, 0.01, 0.000631],
    reso: [0.153846, 0.085714, 0.067194, 0.051429, 0.040404],
  },
  {
    name: "counterTenorA",
    freq: [660, 1120, 2750, 3000, 3350],
    amp: [1.0, 0.501187, 0.070795, 0.063096, 0.012589],
    reso: [0.121212, 0.080357, 0.043636, 0.043333, 0.041791],
  },
  {
    name: "counterTenorE",
    freq: [440, 1800, 2700, 3000, 3300],
    amp: [1.0, 0.199526, 0.125893, 0.1, 0.1],
    reso: [0.159091, 0.044444, 0.037037, 0.04, 0.036364],
  },
  {
    name: "counterTenorI",
    freq: [270, 1850, 2900, 3350, 3590],
    amp: [1.0, 0.063096, 0.063096, 0.015849, 0.015849],
    reso: [0.148148, 0.048649, 0.034483, 0.035821, 0.033426],
  },
  {
    name: "counterTenorO",
    freq: [430, 820, 2700, 3000, 3300],
    amp: [1.0, 0.316228, 0.050119, 0.079433, 0.019953],
    reso: [0.093023, 0.097561, 0.037037, 0.04, 0.036364],
  },
  {
    name: "counterTenorU",
    freq: [370, 630, 2750, 3000, 3400],
    amp: [1.0, 0.1, 0.070795, 0.031623, 0.019953],
    reso: [0.108108, 0.095238, 0.036364, 0.04, 0.035294],
  },
  {
    name: "tenorA",
    freq: [650, 1080, 2650, 2900, 3250],
    amp: [1.0, 0.501187, 0.446684, 0.398107, 0.079433],
    reso: [0.123077, 0.083333, 0.045283, 0.044828, 0.043077],
  },
  {
    name: "tenorE",
    freq: [400, 1700, 2600, 3200, 3580],
    amp: [1.0, 0.199526, 0.251189, 0.199526, 0.1],
    reso: [0.175, 0.047059, 0.038462, 0.0375, 0.03352],
  },
  {
    name: "tenorI",
    freq: [290, 1870, 2800, 3250, 3540],
    amp: [1.0, 0.177828, 0.125893, 0.1, 0.031623],
    reso: [0.137931, 0.048128, 0.035714, 0.036923, 0.033898],
  },
  {
    name: "tenorO",
    freq: [400, 800, 2600, 2800, 3000],
    amp: [1.0, 0.316228, 0.251189, 0.251189, 0.050119],
    reso: [0.1, 0.1, 0.038462, 0.042857, 0.04],
  },
  {
    name: "tenorU",
    freq: [350, 600, 2700, 2900, 3300],
    amp: [1.0, 0.1, 0.141254, 0.199526, 0.050119],
    reso: [0.114286, 0.1, 0.037037, 0.041379, 0.036364],
  },
  {
    name: "bassA",
    freq: [600, 1040, 2250, 2450, 2750],
    amp: [1.0, 0.446684, 0.354813, 0.354813, 0.1],
    reso: [0.1, 0.067308, 0.048889, 0.04898, 0.047273],
  },
  {
    name: "bassE",
    freq: [400, 1620, 2400, 2800, 3100],
    amp: [1.0, 0.251189, 0.354813, 0.251189, 0.125893],
    reso: [0.1, 0.049383, 0.041667, 0.042857, 0.03871],
  },
  {
    name: "bassI",
    freq: [250, 1750, 2600, 3050, 3340],
    amp: [1.0, 0.031623, 0.158489, 0.079433, 0.039811],
    reso: [0.24, 0.051429, 0.038462, 0.039344, 0.035928],
  },
  {
    name: "bassO",
    freq: [400, 750, 2400, 2600, 2900],
    amp: [1.0, 0.281838, 0.089125, 0.1, 0.01],
    reso: [0.1, 0.106667, 0.041667, 0.046154, 0.041379],
  },
  {
    name: "bassU",
    freq: [350, 600, 2400, 2675, 2950],
    amp: [1.0, 0.1, 0.025119, 0.039811, 0.015849],
    reso: [0.114286, 0.133333, 0.041667, 0.04486, 0.040678],
  },
];

export const pickFormantPreset = (index) =>
  FORMANT_PRESETS[Math.max(0, Math.min(FORMANT_PRESETS.length - 1, index))];

export const pickRandomFormantPreset = (random = Math.random) =>
  FORMANT_PRESETS[Math.floor(random() * FORMANT_PRESETS.length)];

export const formantPresetToOscArgs = (preset) => {
  const args = [];
  for (let i = 0; i < 5; i++) {
    args.push(
      { type: "s", value: `ff${i}` },
      { type: "f", value: preset.freq[i] },
      { type: "s", value: `fr${i}` },
      { type: "f", value: preset.reso[i] },
      { type: "s", value: `fa${i}` },
      { type: "f", value: preset.amp[i] },
    );
  }
  return args;
};
